































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import pxCard from '@/dex-shared/components/px-card.vue';

export default Vue.extend({
  components: {
    pxCard,
    CloseIcon,
  },

  props: {
    questionId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      newTag: '',
      //TODO get disciplines from boards
      disciplines: [
        'Matemática',
        'Física',
        'Química',
        'Biologia',
        'História',
        'Geografia',
        'Sociologia',
        'Filosofia',
        'Literatura',
        'Língua Portuguesa',
        'Redação',
        'Inglês',
        'Biologia Celular',
        'Embriologia',
        'Histologia',
        'Francês',
        'Espanhol',
      ],
      questionModes: [
        { type: 'discursive', name: 'Discursiva' },
        { type: 'formula', name: 'Fórmula' },
        { type: 'objective', name: 'Múltipla escolha' },
        { type: 'essay', name: 'Redação' },
        { type: 'binary', name: 'Verdadeiro ou falso - Uma opção correta' },
        {
          type: 'multibinary',
          name: 'Verdadeiro ou falso - Multiplas opções corretas',
        },
        { type: 'practice', name: 'Atividade prática' },
      ],
    };
  },

  computed: {
    ...mapGetters({
      questionById: 'questionById',
      examModeById: 'examModeById',
      allExamModes: 'allExamModes',
    }),

    question() {
      return this.questionById(this.questionId);
    },

    source: function() {
      return this.question.source;
    },

    tags: function() {
      return this.question.tags;
    },

    questionExamMode: {
      get() {
        return this.question.examModeId;
      },
      set(value: number) {
        this.$store.commit('UPDATE_ENTITY_PROP', {
          id: this.question.id,
          entity: 'questions',
          propToUpdate: 'examModeId',
          value,
        });
      },
    },

    questionMode: {
      get() {
        return this.question.mode;
      },
      set(value: string) {
        this.$store.commit('UPDATE_ENTITY_PROP', {
          id: this.question.id,
          entity: 'questions',
          propToUpdate: 'mode',
          value,
        });
      },
    },

    institution: {
      get() {
        return this.source.institution;
      },
      set(value: string) {
        this.updateSource('institution', value);
      },
    },
    year: {
      get() {
        return this.source.year;
      },
      set(value: string) {
        this.updateSource('year', value);
      },
    },
    number: {
      get() {
        return this.source.number;
      },
      set(value: string) {
        this.updateSource('number', value);
      },
    },
    sourceDiscipline: {
      get() {
        return this.source.discipline;
      },
      set(value: string) {
        this.updateSource('discipline', value);
      },
    },
  },
  created: function() {
    this.$store.dispatch('PULL_EXAM_MODES');
  },
  methods: {
    updateSource(sourceProp: string, value: string) {
      this.$store.commit('UPDATE_ENTITY_PROP', {
        id: this.question.id,
        entity: 'questions',
        propToUpdate: 'source',
        value: {
          ...this.source,
          [sourceProp]: value,
        },
      });
    },

    updateTags: function(newTags) {
      this.$store.commit('UPDATE_ENTITY_PROP', {
        id: this.question.id,
        entity: 'questions',
        propToUpdate: 'tags',
        value: newTags,
      });
    },

    onEnter: function(e) {
      e.preventDefault();
      const tags = this.tags ? this.tags.split(',') : [];
      const updatedTags = [...tags, ...this.newTag.split(',')];
      this.updateTags(updatedTags.join(','));
      this.newTag = '';
    },

    getTagsList: function() {
      return this.tags && this.tags.length
        ? this.tags.split(',').filter(t => t !== '')
        : [];
    },

    removeTag: function(tag) {
      const newTags = this.tags
        .split(',')
        .filter(t => t !== tag)
        .join(',');
      this.updateTags(newTags);
    },
  },
});
